import axiosInstance from "./axiosConfig";

// API endpoint for users
const USERS_URL = "/users";

/**
 * Get all users (admin only)
 * @param {Object} params - Query parameters
 * @param {number} params.page - Page number
 * @param {number} params.limit - Number of items per page
 * @param {string} params.search - Search query
 * @returns {Array} List of users
 */
const getUsers = async (params = {}) => {
  const response = await axiosInstance.get(USERS_URL, { params });
  return response.data;
};

/**
 * Get user by ID
 * @param {string} id - User ID
 * @returns {Object} User data
 */
const getUserById = async (id) => {
  const response = await axiosInstance.get(`${USERS_URL}/${id}`);
  return response.data;
};

/**
 * Update user
 * @param {string} id - User ID
 * @param {Object} userData - User data to update
 * @returns {Object} Updated user data
 */
const updateUser = async (id, userData) => {
  const response = await axiosInstance.put(`${USERS_URL}/${id}`, userData);
  return response.data;
};

/**
 * Delete user (admin only)
 * @param {string} id - User ID
 * @returns {Object} Success message
 */
const deleteUser = async (id) => {
  const response = await axiosInstance.delete(`${USERS_URL}/${id}`);
  return response.data;
};

const userService = {
  getUsers,
  getUserById,
  updateUser,
  deleteUser,
};

export default userService;
